import { useMemo, useContext } from 'react';
import { getCDNImage } from '../globals';
import { i18nValue } from '../functions';
import { HotelContext } from '../context/hotel'
import '../index.css';
import { UserContext } from '../context/user';
import { NavLink, useLocation } from 'react-router-dom';
import { isAlvarezArguellez, isCostaGalana, isDemo, isHostz, isHostzArosa, isHostzBecozy, isHostzBetaHouse, isHostzBlackSummit, isHostzCozy, isHostzMyde, isHostzSigma, isHostzSteiners, isHostzSwissstay, isRoyal, isSimplex } from "../components/CheckIn/hotelConditions";
import { T } from "react-translator-component";
// let routes = {
//     'info' : {
//         route : 'hotel',
//         // name : 'Hotel Information',
//         // img : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOBrpNyXPA45o99TSmkhxaDrrH-mz-UXz0mg&usqp=CAU'
//     },
//     'booking': {
//         route : 'booking'
//     },
//     // 'room_service_menu' : {
//     //     route : 'hotel',
//     //     name : 'Room Service Menu',
//     //     img : 'https://i.pinimg.com/originals/bc/94/25/bc942528cb9c7d0532058852d531d5ce.jpg'
//     // },
//     // 'restaurant_reservation' : {
//     //     route : 'restaurant_reservation',
//     //     // name : 'Restaurant Reservation',
//     //     // img : 'https://d3h1lg3ksw6i6b.cloudfront.net/media/image/2019/05/15/de44fc70d70e4996b6014d9e2e8cb1d7_shutterstock_1011895627.jpg'
//     // },
//     'restaurants' : {
//         route : 'restaurants',
//         // name : 'Restaurants',
//         // img : 'https://d3h1lg3ksw6i6b.cloudfront.net/media/image/2019/05/15/de44fc70d70e4996b6014d9e2e8cb1d7_shutterstock_1011895627.jpg'
//     },
//     'fast_checkin' : {
//         route : 'checkin',
//         in_hotel : false
//         // name : 'Fast Check In',
//         // img : 'https://conceptodefinicion.de/wp-content/uploads/2013/09/check-in-2.jpg'
//     },
//     'identify' : {
//         route : 'identify',
//         in_hotel : false
//     },
//     // 'services' : {
//     //     route : 'services',
//     //     // name : 'Services',
//     //     // img : 'https://www.dossierweb.com.ar/wp-content/uploads/2020/08/Chamberlain_IsRoomServiceDead.jpg'
//     // },
//     'rooms' : {
//         route : 'room_categories',
//         // name : 'Rooms',
//         // img : 'https://www.melia.com/dam/jcr:2b088eee-4910-4c75-a713-8cdfdcf04e12/107MeliaCaribeBeach-Family_Room_Beach_Side.jpg'
//     },
//     'hotel_facilities' : {
//         route : 'facilities',
//         // name : 'Hotel Facilities',
//         // img : 'https://www.hotelprakashsiwan.com/ckfinder/userfiles/images/h%20service4.jpg'
//     },
//     'meeting_rooms' : {
//         route : 'meeting_rooms',
//         // name : 'Meeting Rooms',
//         // img : 'https://www.thespruce.com/thmb/j3IeM4TkhyZG-NX9dr65BDQ4Jnw=/450x0/filters:no_upscale():max_bytes(150000):strip_icc()/Traditional-Beach-House-Living-Room-589a78c33df78caebcbc63a6.png'
//     },
//     'facilities' : {
//         route : 'facilities',
//         // name : 'Meeting Rooms',
//         // img : 'https://www.thespruce.com/thmb/j3IeM4TkhyZG-NX9dr65BDQ4Jnw=/450x0/filters:no_upscale():max_bytes(150000):strip_icc()/Traditional-Beach-House-Living-Room-589a78c33df78caebcbc63a6.png'
//     },
//     // 'tours' : {
//     //     route : 'hotel',
//     //     name : 'Tours',
//     //     img : 'https://juliatravel.com/es/files/4415/6328/8827/tours-barcelona.jpg'
//     // }
// }

const HomeMenu = ({ codeClient, type = 'rows' }) => {
    const { data, sectionsByCode, getUrlPath } = useContext(HotelContext)
    const { language } = useContext(UserContext)
    const homeMenu = data.settings?.homeMenu || [];
    const { pathname } = useLocation();

    const items = useMemo(() => {
        let _items = []
        let _keys = homeMenu && homeMenu.length > 0
            ? homeMenu
            : Object.values(sectionsByCode)
                .filter(section => !section?.parent)
                .map(section => section.code);
        // _keys = _keys.filter(i => i.indexOf('service_') === -1)
        // TODO: Parche ... hacerlo con prefijo luego
        _keys = _keys.filter(i => i.indexOf('service_') === -1 && i !== 'stay_add_device' && i !== 'stay' && i !== 'services')
        // ---------------------
        // console.log('2106 - _keys', _keys)
        _keys.map(i => {
            if (sectionsByCode[i] && sectionsByCode[i].visible && !sectionsByCode[i].parent) {
                _items.push(sectionsByCode[i])
            }
            return i
        })
        return _items
    }, [homeMenu, sectionsByCode])

    const appendContactByWhatsapp = () => {

        // Area where you are not logged in: The button ""Chat 24 / 7"" is always in the second place 
        // The Myde: https://wa.me/4915566511786
        // Basel: https://wa.me/41783126350
        // Black Summit: https://wa.me/41715391837
        // Arosa: https://wa.me/41798073777

        let number = null;
        let image = "rgba(0,0,0,.5)";
        if (isHostz(data?.id)) {
            if (isHostzBetaHouse(data?.id)) {
                // number = "41782247770";
                number = "41445052256";
                image = "url('https://cdn.vicomanager.com/assets/sigma_btn.jpg')";
            }
            if (isHostzBecozy(data?.id)) {
                number = "41783126350";
            }
            if (isHostzMyde(data?.id)) {
                number = "4915566511786";
                image = "rgba(0,0,0,.5) url('https://cdn.vicomanager.com/assets/themyde-contact-home.jpg')";
            }
            if (isHostzArosa(data?.id)) {
                number = "41798073777";
                image = "url('https://cdn.vicomanager.com/assets/arosa_btn_red.jpg')";
            }
            if (isHostzCozy(data?.id)) {
                number = "41798076888";
                image = "url('https://cdn.vicomanager.com/assets/cozy_btn.png')";
            }
            if (isHostzSwissstay(data?.id)) {
                number = "41798077220";
            }
            if (isHostzSteiners(data?.id)) {
                number = "41755730222";
            }
            if (isHostzSigma(data?.id)) {
                number = "41445052256";
                image = "url('https://cdn.vicomanager.com/assets/sigma_btn.jpg')";
            }
        }
        if (isSimplex(data?.id)) {
            number = "497219098790";
        }

        if (number) {
            return (
                <a
                    key={`home-menu-item-whatsapp-contact`}
                    className={`home-menu-item-type-rows`}
                    style={{ color: 'white' }}
                    target='_blank'
                    href={`https://wa.me/${number}`}>
                    <span className="menu-image-span">{T("home.chat-24-7")}</span>
                    <div className="menu-image" style={{ background: image }}>
                    </div>
                </a>
            )
        }

        return null;
    }
    const appendBookingButton = () => {

        let url = null;
        let image = "rgba(0,0,0,.5)";
        if (isHostz(data?.id)) {
            if (isHostzBecozy(data?.id)) {
                url = "https://booking.roomcloud.net/be/se2/hotel.jsp?hotel=19036";
                // image = "rgba(0,0,0,.5) url('http://cdn.vicomanager.com/assets/becozy-booking-home.jpg')";
            }
            if (isHostzBlackSummit(data?.id)) {
                url = "https://laax.blacksummit.ch/book/";
                // image = "rgba(0,0,0,.5) url('http://cdn.vicomanager.com/assets/blacksummit-booking-home.jpg')";
            }
            if (isHostzArosa(data?.id)) {
                url = "https://booking.roomcloud.net/be/se2/hotel.jsp?hotel=20410";
                image = "url('http://cdn.vicomanager.com/assets/arosa_btn_red.jpg')";
            }
            if (isHostzBetaHouse(data?.id)) {
                url = "https://booking.roomcloud.net/be/se2/hotel.jsp?hotel=20255";
                // image = "rgba(0,0,0,.5) url('http://cdn.vicomanager.com/assets/betahouse-booking-home.jpg')";
            }
            if (isHostzCozy(data?.id)) {
                url = "https://booking.roomcloud.net/be/se2/hotel.jsp?hotel=20898";
                image = "url('http://cdn.vicomanager.com/assets/cozy_btn.png')";
            }
            if (isHostzMyde(data?.id)) {
                url = "https://booking.roomcloud.net/be/se2/hotel.jsp?hotel=20501";
                // image = "rgba(0,0,0,.5) url('http://cdn.vicomanager.com/assets/themyde-booking-home.jpg')";
            }
            if (isHostzSwissstay(data?.id)) {
                url = "http://www.swissstay.ch/";
                // image = "rgba(0,0,0,.5) url('http://cdn.vicomanager.com/assets/swissstay-booking-home.jpg')";
            }
            if (isHostzSteiners(data?.id)) {
                url = "https://booking.roomcloud.net/be/se2/hotel.jsp?hotel=21177";
                // image = "rgba(0,0,0,.5) url('http://cdn.vicomanager.com/assets/swissstay-booking-home.jpg')";
            }
            if (isHostzSigma(data?.id)) {
                url = "https://direct-book.com/properties/sigmahostel";
                image = "url('https://cdn.vicomanager.com/assets/sigma_btn.jpg')";
            }
        }
        if (isSimplex(data?.id)) {
            // url = "#";
            // image = "rgba(0,0,0,.5) url('http://cdn.vicomanager.com/assets/swissstay-booking-home.jpg')";
        }

        if (url) {
            return (
                <a
                    key={`home-menu-item-booking`}
                    className={`home-menu-item-type-rows`}
                    style={{ color: 'white' }}
                    target='_blank'
                    href={url}>
                    <span className="menu-image-span">
                      {T(
                        isHostzBlackSummit(data?.id)
                          ? "home.book-an-apartment"
                          : "home.book-a-room"
                      )}
                    </span>
                    <div className="menu-image" style={{ background: image }}>
                    </div>
                </a>
            )
        }

        return null;
    }

    // let _items = [];
    // if (options) {
    //     options.map(item => routes[item.code] ? _items.push({ ...item, route : routes[item.code].route, in_hotel : routes[item.code].in_hotel ?? true }) : false);
    // }
    //  else {
    //     _items = Object.values(routes);
    // }
    return (
        <>
            {(isDemo(data?.id) || isRoyal(data?.id)) && (
                <NavLink key={`home-menu-item-${type}`} className={`home-menu-item-type-${type}`} style={{ color: 'white' }} to={`/${codeClient}/public/services`} state={{ from: pathname }}>
                    <span className="menu-image-span">{T("services.make-your-reservation-button")}</span>
                    <div className="menu-image" style={
                        { background: `rgba(0,0,0,.5) url("https://cdn-dev.vicomanager.com/public/511e8df9-672d-42b1-9711-d82beb7baf64/section_restaurants_1698751016088.jpg")` }}></div>
                </NavLink>
            )}

            <div className={`home-menu-type-${type}`}>

                {(isSimplex(data?.id)) && appendContactByWhatsapp()}

                {

                    items && items.map((val, idx) => {

                        if (val.visible === true) {
                            // if (roomOccupationId && val.in_hotel === false) return null;
                            const _image = val.image !== null ? "url(" + getCDNImage(val.image) + ")" : '';
                            let uri = val.code;

                            // if (checkIn?.id) {
                            //     if (uri === 'fast_checkin' || uri === 'identify') {
                            //         return false;
                            //     }
                            // }

                            if (uri === 'fast_checkin') uri = 'checkin/info';
                            if (uri === 'identify') uri = 'checkin/identify';
                            return (
                                <>
                                    {
                                        (idx == 1 && !isSimplex(data?.id)) && appendContactByWhatsapp()
                                    }
                                    {
                                        (idx == 1) && appendBookingButton()
                                    }

                                    <NavLink key={`home-menu-item-${idx}`} className={`home-menu-item-type-${type}`} style={{ color: 'white' }} to={getUrlPath(uri)} state={{ from: pathname }}>
                                        <span className="menu-image-span">{i18nValue(val, 'title', language)}</span>
                                        <div className="menu-image" style={{ background: (type === "icons" ? `rgba(0,0,0,.5) ${_image}` : `rgba(0,0,0,.5) ${_image}`) }}></div>
                                    </NavLink>
                                </>
                            )
                        }
                        return false
                    })}

                {/* {codeClient.indexOf('test') !== -1 && <NavLink key={`home-menu-item-sys`} className={`home-menu-item-type-${type}`} style={{ color: 'white' }} to={`/${codeClient}/system`} state={{ from: pathname }}>
                    <span className="menu-image-span">System</span>
                    <div className="menu-image" style={{ background: (type === "icons" ? `none` : `rgb(0,0,0)`)}}></div>
                </NavLink>} */}



            </div>
        </>
    )
}


export default HomeMenu;